import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8 12H12M8 9H16M4.75 16.25V6C4.75 5.30964 5.30964 4.75 6 4.75H18C18.6904 4.75 19.25 5.30964 19.25 6V15C19.25 15.6904 18.6904 16.25 18 16.25H8L5.62784 18.9871C5.32471 19.3369 4.75 19.1225 4.75 18.6596V16.25Z" vectorEffect="non-scaling-stroke" />
	</SVG>
);
